import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import CloseLineIcon from '@icons/CloseLineIcon';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import styles from './styles.module.scss';

export interface Props {
    isOpen: boolean;
    close: () => void;
    title: string;
    options?: {value: string, label: string}[];
    onChange?: (v: string) => void;
}

function BottomSheetComponent({
  isOpen, close, title, options, onChange,
}:Props) {
  const bgRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isOpen) {
      bgRef.current?.classList.remove(styles.none);
      const showTimeout = setTimeout(() => {
        bgRef.current?.classList.remove(styles.hide);
      }, 50);
      return () => clearTimeout(showTimeout);
    }
    bgRef.current?.classList.add(styles.hide);
    const closeTimeout = setTimeout(() => {
      bgRef.current?.classList.add(styles.none);
    }, 200);
    return () => clearTimeout(closeTimeout);
  }, [isOpen]);
  return (
        <div ref={bgRef}
                    onClick={close}
                    className={`${styles.background} ${styles.hide} ${styles.none}`}>
            <div className={styles.container}
                       onClick={(e) => {
                         e.stopPropagation();
                         e.preventDefault();
                       }} >
                <Row justify='space-between'
                     fullWidth >
                    <Text color={colors.gray6} >
                        {title}
                    </Text>
                    <CloseLineIcon onClick={close}
                    size={24}/>
                </Row>
                {options?.map((option, index) => (
                    <Text key={`option ${index}`}
                          className={styles.filter}
                          onClick={() => {
                            close();
                            onChange?.(option.value);
                          }} >
                        {option.label}
                    </Text>
                ))}
            </div>
        </div>
  );
}

function BottomSheet(props: Props) {
  return createPortal(<BottomSheetComponent {...props} />, document.body);
}

export default BottomSheet;
